"use client";

import { cn } from "@/utils";
import { usePathname } from "next/navigation";
import React, { FC } from "react";

type Props = {
  record: {
    id: string
    title: string
  };
  onClick?: () => void;
  activeSection: string;
};

const HeaderItem: FC<Props> = ({ record, activeSection, onClick }) => {
  const pathname = usePathname();
  const isActive =
    pathname.includes("/blog")
      ? record.id === "blog"
      : pathname.includes("/careers")
      ? record.id === "careers"
      : activeSection === record.id;

  return (
    <button
      className={cn(
        "relative px-4 py-2 text-base text-center font-medium hover:text-lightBlue whitespace-nowrap",
        isActive ? "text-primary font-bold" : "text-tblack"
      )}
      onClick={onClick}
    >
      {record.title}
      <span
        className={cn(
          "absolute left-0 bottom-0 h-[2px] bg-primary transition-all duration-300 ease-in-out",
          isActive ? "w-full px-4" : "w-0"
        )}
      ></span>
    </button>
  );
};

export default HeaderItem;
